import React, { useContext, useEffect, useState } from 'react';
import '../TabNotificationRow.scss';
import './TabNotificationRowCoordinator.scss';
import { Appeal } from '../../../model/Appeal';
import { Select, Button } from 'antd';
import { User } from '../../../model/User';
import { shortUserName } from '../../../utils/formatter';
import { Context } from '../../../index';

interface TabNotificationRowCoordinatorProps {
  appeal: Appeal;
  handleAppealRemove: (appealId: number) => void;
}

const TabNotificationRowCoordinator = (
  props: TabNotificationRowCoordinatorProps
): JSX.Element => {
  const [executors, setExecutors] = useState<User[]>([]);
  const [directors, setDirectors] = useState<User[]>([]);
  const [currentExecutor, setCurrentExecutor] = useState<number>(0);
  const [currentDirectors, setCurrentDirectors] = useState<number[]>([]);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(false);
  const { store } = useContext(Context);

  useEffect(() => {
    store.getCoordinators().then((resp) => {
      if (resp) {
        setExecutors(resp.executors);
        setDirectors(resp.directors);
      }
    });
  }, []);

  const handleCoordination = () => {
    setIsSubmitDisabled(true);
    const coordinationExecutors = {
      executor: currentExecutor,
      directorId: currentDirectors,
    };

    store
      .setAppealCoordination(props.appeal.id, coordinationExecutors)
      .then((res) => {
        if (res) {
          props.handleAppealRemove(props.appeal.id);
        }
        setTimeout(() => {
          setIsSubmitDisabled(false);
        }, 300);
      });
  };

  return (
    <div className="tabNotificationRowCoordinator">
      <label>Исполнитель</label>
      <Select
        placeholder="Выберите из списка"
        className="problemReportSelect"
        optionLabelProp="label"
        onChange={(value) => setCurrentExecutor(value as number)}
      >
        {executors.map((item: User, index: number) => {
          return (
            <Select.Option
              key={index}
              label={shortUserName(item)}
              value={item.id}
            >
              <span>
                {item.lastName} {item.firstName} {item.middleName}
              </span>
            </Select.Option>
          );
        })}
      </Select>
      <label>Руководитель</label>
      <Select
        placeholder="Выберите из списка"
        className="problemReportSelect"
        optionLabelProp="label"
        mode="multiple"
        allowClear
        onChange={(value) => setCurrentDirectors(value as number[])}
      >
        {directors.map((item: User, index: number) => {
          return (
            <Select.Option
              key={index}
              label={shortUserName(item)}
              value={item.id}
            >
              <span>
                {item.lastName} {item.firstName} {item.middleName}
              </span>
            </Select.Option>
          );
        })}
      </Select>
      <Button.Group>
        <Button
          type="primary"
          onClick={() => handleCoordination()}
          disabled={
            !currentDirectors.length || !currentExecutor || isSubmitDisabled
          }
        >
          Сохранить
        </Button>
      </Button.Group>
    </div>
  );
};

export default TabNotificationRowCoordinator;
